module.exports = "<span class=oui-progress__label ng-transclude>{{$ctrl.value + '%'}}</span> ";